// State and city (Iran). The lists come from `get_iranian_states_and_cities_query` (the storefront API's getAllStates /
// getAllCities, as in the older forms) and are loaded once by the hook when the form has such a field; the value kept is { title, value }.
// A city lists only the cities of the state chosen in the same group (and the same repeat instance).
import { h } from "../h.js";
import { slot_props } from "../styles.js";
import { label_of } from "../messages.js";
import { FieldShell, control_aria } from "./shell.js";

// the rows -> { value, title, state_id }, whatever names the row uses for its id and name. The title is `native` first:
// getAllStates / getAllCities put the English name in `name` and the Persian one in `native` (the settings had both Persian).
export const normalize_geo = (raw) => {
    const rows = (list) => (Array.isArray(list) ? list : []).map((row) => ({
        value: String(row?.value ?? row?.id ?? ""),
        title: String(row?.native || row?.name || row?.title || ""),
        state_id: row?.state_id === undefined || row?.state_id === null ? undefined : String(row.state_id),
    })).filter((row) => row.value !== "");
    return { states: rows(raw?.states), cities: rows(raw?.cities) };
};

export const cities_of_state = (geo, state_value) => {
    const cities = geo?.cities || [];
    if (state_value === undefined || state_value === null || state_value === "") {
        return [];
    }
    return cities.filter((city) => String(city.state_id) === String(state_value));
};

export const GeoField = ({ field, id, value, on_change, error, required, disabled, styles, class_names, lang, messages, geo, state_value, all_cities }) => {
    const is_city = field.type === "city";
    // a city lists the cities of the state picked in its group; a group with no state field lists them all
    const list = is_city ? (all_cities ? (geo?.cities || []) : cities_of_state(geo, state_value)) : (geo?.states || []);
    const loading = !geo;
    const current = value && typeof value === "object" ? value.value : value;
    const control = h(
        "select",
        {
            ...control_aria({ id, field, error, required, disabled: disabled || loading }),
            ...slot_props({ slot: "input", class_names, styles, type: field.type }),
            value: current === undefined ? "" : String(current),
            onChange: (event) => {
                const found = list.find((item) => item.value === event.target.value);
                on_change(found ? { title: found.title, value: found.value } : undefined);
            },
        },
        h("option", { value: "" }, loading ? label_of("loading", lang, messages) : (field.placeholder || label_of("choose", lang, messages))),
        ...list.map((item) => h("option", { key: item.value, value: item.value }, item.title)),
    );
    return h(FieldShell, { field, id, error, required, disabled, styles, class_names }, control);
};
